import React from 'react';
import { Button } from '../../../general/Button';

export const GoalQuestionBase: React.FC<{
    header?: {
        title?: string;
        description?: string;
    };
    buttons?: {
        next?: {
            id: string;
            label: string;
            onClick: React.MouseEventHandler<HTMLButtonElement>;
            isDisabled?: boolean;
        };
        previous?: {
            id: string;
            label: string;
            onClick: React.MouseEventHandler<HTMLButtonElement>;
        };
    };
    pageNumberIndicators?: {
        current: number;
        total: number;
    };
    children?: React.ReactNode;
}> = ({ pageNumberIndicators, buttons, children, header }) => {
    return (
        <div className="flex flex-col items-center py-16 px-4 md:px-8">
            <h2 className="text-bnd-black text-4xl text-center font-medium">{header?.title}</h2>
            {header?.description && (
                <p className="mt-4 text-left text-bnd-black max-w-7xl w-full">
                    {header?.description}
                </p>
            )}
            {pageNumberIndicators && (
                <span className="mt-16 font-medium">
                    Stap {pageNumberIndicators.current}/{pageNumberIndicators.total}
                </span>
            )}
            <div
                className="flex flex-col items-between justify-center mt-8 p-8 px-8 md:px-12 max-w-7xl w-full bg-white shadow-lg rounded-lg"
                style={{ minHeight: '200px' }}
            >
                {children}
            </div>
            {buttons && (
                <div className="mt-8 grid grid-cols-2 gap-8 ">
                    {buttons.previous !== undefined ? (
                        <Button id={buttons.previous.id} onClick={buttons.previous?.onClick} buttonType={'secondary'}>
                            {buttons.previous?.label}
                        </Button>
                    ) : (
                        <div></div>
                    )}
                    {buttons.next !== undefined ? (
                        <Button
                            isDisabled={buttons.next.isDisabled || false}
                            id={buttons.next.id}
                            onClick={buttons.next?.onClick}
                            buttonType={'primary'}
                        >
                            {buttons.next?.label}
                        </Button>
                    ) : (
                        <div></div>
                    )}
                </div>
            )}
        </div>
    );
};
